import NotificationUtils from './NotificationUtils';

export default class ClipboardUtils {
	public static async copyToClipboard(text: string) {
		await navigator.clipboard.writeText(text);
	}

	public static async copyToClipboardWithNotification(text: string) {
		try {
			await this.copyToClipboard(text);
			NotificationUtils.showSuccess('Link Copied!', 'Successfully copied to clipboard.');
		} catch (err) {
			NotificationUtils.showError(err as Error, 'Failed to copy to clipboard.');
		}
	}
}
